import React, { useEffect, useRef, useState } from "react";
import WaveSurfer from "wavesurfer.js";
import RegionsPlugin from "wavesurfer.js/dist/plugin/wavesurfer.regions.min";
import TimelinePlugin from "wavesurfer.js/dist/plugin/wavesurfer.timeline.min";
import CursorPlugin from "wavesurfer.js/dist/plugin/wavesurfer.cursor.min";

const AudioWaveform = ({
    audioFile,
    waveformData,
    regionStart,
    regionEnd,
    currentTime,
    onTimeClick,
    onRegionChange,
}) => {
    const waveformRef = useRef(null);
    const wavesurfer = useRef(null);
    const region = useRef(null);
    const [loadingProgress, setLoadingProgress] = useState(0);
    const [loadingComplete, setLoadingComplete] = useState(false);
    const [durationExceedsLimit, setDurationExceedsLimit] = useState(false);

    useEffect(() => {
        const checkDuration = async () => {
            const audio = new Audio(audioFile);
            audio.onloadedmetadata = () => {
                const duration = audio.duration;
                if (duration > 2 * 3600) {
                    setDurationExceedsLimit(true);
                } else {
                    setDurationExceedsLimit(false);
                }
            };
        };

        checkDuration();
    }, [audioFile]);

    useEffect(() => {
        if (waveformRef.current && !durationExceedsLimit) {
            waveformRef.current.style.height = "172px"; // Set the height

            wavesurfer.current = WaveSurfer.create({
                container: waveformRef.current,
                waveColor: "violet",
                progressColor: "purple",
                plugins: [
                    RegionsPlugin.create(),
                    TimelinePlugin.create({ container: "#timeline" }),
                    CursorPlugin.create(),
                ],
            });

            wavesurfer.current.on("loading", (progress) => {
                setLoadingProgress(progress);
            });

            wavesurfer.current.on("ready", () => {
                setLoadingComplete(true);
            });

            if (waveformData) {
                wavesurfer.current.loadDecodedBuffer(waveformData);
            } else {
                wavesurfer.current.load(audioFile);
            }

            return () => {
                wavesurfer.current.destroy();
            };
        }
    }, [audioFile, waveformData, durationExceedsLimit]);

    useEffect(() => {
        if (wavesurfer.current && !durationExceedsLimit) {
            if (region.current) {
                region.current.remove();
                region.current = null;
            }

            if (regionStart !== null && regionEnd !== null) {
                region.current = wavesurfer.current.addRegion({
                    start: regionStart,
                    end: regionEnd,
                    color: "hsla(100, 30%, 70%, 0.3)",
                });

                region.current.on("update-end", () => {
                    const updatedRegionStart = region.current.start;
                    const updatedRegionEnd = region.current.end;
                    onRegionChange(updatedRegionStart, updatedRegionEnd);
                });
            }
        }
    }, [regionStart, regionEnd, durationExceedsLimit]);

    useEffect(() => {
        if (
            wavesurfer.current &&
            typeof currentTime === "number" &&
            !durationExceedsLimit
        ) {
            const duration = wavesurfer.current.getDuration();
            if (duration > 0) {
                const position = currentTime / duration;
                wavesurfer.current.seekTo(position);
            }
        }
    }, [currentTime, durationExceedsLimit]);

    const handleMouseUp = () => {
        if (wavesurfer.current && loadingComplete) {
            setTimeout(() => {
                const currentTime = wavesurfer.current.getCurrentTime();
                console.log("Clicked time:", currentTime);
                onTimeClick(currentTime);
            }, 10);
        }
    };

    if (durationExceedsLimit) {
        return (
            <div>
                {/* Аудиофайл слишком длинный для отображения волновой формы. */}
            </div>
        );
    }

    return (
        <div style={{ height: "172px" }} onMouseUp={handleMouseUp}>
            <div id="timeline"></div>
            <div id="waveform" ref={waveformRef}></div>
            {!loadingComplete && (
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        marginTop: "10px",
                    }}
                >
                    <div
                        style={{
                            flex: 1,
                            height: "3px",
                            backgroundColor: "#e0e0e0",
                        }}
                    >
                        <div
                            style={{
                                width: `${loadingProgress}%`,
                                height: "100%",
                                backgroundColor: "#3b5998",
                            }}
                        ></div>
                    </div>
                    <div style={{ marginLeft: "10px" }}>
                        {Math.round(loadingProgress)}%
                    </div>
                </div>
            )}
        </div>
    );
};

export default AudioWaveform;
